var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"width":"100%","height":"calc(100vh - 60px)"},attrs:{"src":"/app#/gismobile","frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }